<template>
  <router-view />
  <transition name="fade">
    <div v-if="toast.visible" class="toast" :class="`toast-${toast.type}`" role="status">
      <strong v-if="toast.title">{{ toast.title }}</strong>
      <span>{{ toast.message }}</span>
      <button type="button" aria-label="关闭提示" @click="toast.visible = false">×</button>
    </div>
  </transition>
</template>

<script setup>
import { onUnmounted, reactive, watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const toast = reactive({ visible: false, title: '', message: '', type: 'warning' })
let timer

watch(
  () => store.getters.getError,
  error => {
    if (!error?.status) return
    toast.visible = true
    toast.title = error.title || ''
    toast.message = typeof error.message === 'string' ? error.message : '请求处理失败'
    toast.type = error.type || 'warning'
    clearTimeout(timer)
    timer = window.setTimeout(() => (toast.visible = false), 3200)
  },
  { deep: true }
)

onUnmounted(() => clearTimeout(timer))
</script>

<style scoped>
.toast {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 200;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 3px 18px;
  width: min(380px, calc(100vw - 36px));
  padding: 14px 16px;
  border: 1px solid #d5dad7;
  border-left: 4px solid #9a7421;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 14px 36px rgba(24, 32, 29, 0.16);
}
.toast strong, .toast span { grid-column: 1; }
.toast span { color: #58615d; font-size: 13px; }
.toast button { grid-column: 2; grid-row: 1 / 3; border: 0; background: transparent; font-size: 20px; }
.toast-success { border-left-color: var(--success); }
.toast-error { border-left-color: var(--danger); }
</style>
